import { ErrorBoundary } from '@sentry/react'
import { UseQueryResult } from '@tanstack/react-query'
import React from 'react'

import { useDisableBodyScroll } from '../../../../../hooks/useDisableBodyScroll'
import { GlobalSearchResultsItem } from '../../../../../types/responses/global-search'
import SearchBoxResults from './SearchBoxResults'

interface Props {
  globalSearchQuery: UseQueryResult<GlobalSearchResultsItem>
}

const SearchBox: React.FC<Props> = ({ globalSearchQuery }) => {
  const results = globalSearchQuery.data

  useDisableBodyScroll()

  return (
    <div className="bg-white d-flex flex-column gap-4 bg-white">
      <ErrorBoundary
        fallback={
          <div className="alert alert-danger p-3">
            <p className="text-lg mb-0">
              Sorry, it looks we're having a problem with this search. Our team
              has been notified and will attempt to fix the issue as soon as
              possible. Please try again later.
            </p>
          </div>
        }
      >
        <SearchBoxResults
          globalSearchQuery={globalSearchQuery}
          searchResults={results}
        />
      </ErrorBoundary>
    </div>
  )
}

export default SearchBox
